import * as React from 'react';

export const COPY = 'copy';
export const OPTIONS_ACTIONS = [COPY];
